import { FieldTypes } from '@nts/std/types';
import { FieldMetaData } from './field-meta-data';
import { Expose } from '@nts/std/serialization';
import type { SpacerMetaDataInterface } from '@nts/std/interfaces';

export class SpacerMetaData extends FieldMetaData implements SpacerMetaDataInterface {

  @Expose()
  uniqueId: string;

  override getFieldType(): FieldTypes {
    return FieldTypes.Spacer;
  }
}
